import { datadogLogs } from '@datadog/browser-logs';

import { BrowserLogType } from './types';

export function logViewportSize(userId: string) {
  const width = window.innerWidth;
  const screenSize = [
    { categoryName: 'Ultra large', breakpoint: 2400 },
    { categoryName: 'Double extra large', breakpoint: 1600 },
    { categoryName: 'Extra large', breakpoint: 1280 },
    { categoryName: 'Large', breakpoint: 992 },
    { categoryName: 'Medium', breakpoint: 768 },
    { categoryName: 'Small', breakpoint: 576 },
    { categoryName: 'Extra small', breakpoint: 0 },
  ].find((x) => width >= x.breakpoint)?.categoryName;

  datadogLogs.logger.info('Viewport size data', {
    type: BrowserLogType.VIEWPORT_SIZE,
    width,
    height: window.innerHeight,
    screenSize,
    userId, // log only user id and separate prop to avoid exposing PII
  });
}
